import React, { useState } from 'react';
import { CashTipForm } from './CashTipForm';
import { CashTipHistory } from './CashTipHistory';

interface Props {
  tenantId: string;
  isAdminOrManager: boolean;
  userEmail: string;
}

export const CashTipContainer: React.FC<Props> = ({ tenantId, isAdminOrManager, userEmail }) => {
  const [activeTab, setActiveTab] = useState<'submit' | 'history'>('submit');

  return (
    <div className="space-y-6">
      <div className="flex border-b border-gray-200">
        <button
          className={`pb-2 px-4 font-semibold ${activeTab === 'submit' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
          onClick={() => setActiveTab('submit')}
        >
          Submit Tip
        </button>
        <button
          className={`pb-2 px-4 font-semibold ${activeTab === 'history' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
          onClick={() => setActiveTab('history')}
        >
          History
        </button>
      </div>
      {activeTab === 'submit' ? (
        <CashTipForm tenantId={tenantId} isAdminOrManager={isAdminOrManager} />
      ) : (
        <CashTipHistory tenantId={tenantId} userEmail={userEmail} isAdminOrManager={isAdminOrManager} />
      )}
    </div>
  );
};
